
(() => {
  'use strict';
  if (window.__farGiftDefaultsInstalled) return;
  window.__farGiftDefaultsInstalled = true;

  const PRODUCT = '15473597219101';
  const DEAL = '4bea514f-226c-43a1-8abb-a2f653b635e4';
  const TIERS = {
    '872b339a-933f-44f5-ad16-9421e28a3d19': ['S9Da', 'Uvc7'],
    '1e85f2ab-0f25-47aa-9a42-02e21ca46789': ['oHR0', 'emy4']
  };
  const IDS = Object.values(TIERS).flat();
  const BAR = '.kaching-bundles__bar[data-deal-bar-id]';
  const ROW = '.kaching-bundles__upsell[data-upsell-id]';
  const CHECKBOX = '.kaching-bundles__upsell__checkbox';
  const SELECTED = 'kaching-bundles__upsell__checkbox--selected';
  const handled = new Map(); 
  const mounted = new WeakSet();
  const qa = new URLSearchParams(window.location.search).get('far_gift_qa') === '1';

  function scoped(widget) {
    return widget instanceof HTMLElement &&
      widget.matches('kaching-bundles-block') &&
      widget.getAttribute('deal-block-id') === DEAL &&
      !!widget.closest(`kaching-bundle[product-id="${PRODUCT}"]`);
  }

  
  function rememberUser(event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    if (event.type === 'keydown' && !['Enter', ' ', 'Spacebar'].includes(event.key)) return;
    const row = event.target.closest(ROW);
    const widget = row?.closest('kaching-bundles-block');
    const id = row?.getAttribute('data-upsell-id');
    if (scoped(widget) && IDS.includes(id)) handled.set(id, 'user');
  }
  for (const name of ['pointerdown', 'keydown', 'click']) {
    document.addEventListener(name, rememberUser, true);
  }

  function mount(widget) {
    if (!scoped(widget) || mounted.has(widget)) return;
    mounted.add(widget);
    let scheduled = false;
    let observer;
    let stopTimer;
    let dealBarId = null;
    const pre = qa ? document.createElement('pre') : null;
    if (pre) {
      pre.className = 'far-gift-qa';
      pre.setAttribute('aria-label', 'FAR gift QA: official Kaching selection and pricing');
      pre.style.whiteSpace = 'pre-wrap';
      pre.style.overflowWrap = 'anywhere';
      widget.after(pre);
    }

    function report() {
      if (!pre) return;
      try {
        pre.textContent = JSON.stringify({
          productId: PRODUCT, dealId: DEAL, dealBarId,
          handledUpsells: Object.fromEntries(handled),
          items: widget.items(), pricing: widget.pricing()
        }, null, 2);
      } catch (error) {
        pre.textContent = `FAR gift QA: API not ready: ${error.message}`;
      }
    }

    function scan() {
      scheduled = false;
      if (!widget.isConnected || !scoped(widget)) return;
      const bar = widget.querySelector(`${BAR}.kaching-bundles__bar--selected`);
      dealBarId = bar?.getAttribute('data-deal-bar-id') || null;
      if (!bar || !bar.getClientRects().length) { report(); return; }
      for (const id of TIERS[bar.getAttribute('data-deal-bar-id')] || []) {
        if (handled.has(id)) continue;
        const row = bar.querySelector(`${ROW}[data-upsell-id="${id}"]`);
        const checkbox = row?.querySelector(CHECKBOX);
        if (!checkbox || !checkbox.getClientRects().length ||
            getComputedStyle(checkbox).visibility !== 'visible' ||
            checkbox.closest('[hidden], [inert], [aria-disabled="true"]')) continue;
        
        handled.set(id, checkbox.classList.contains(SELECTED) ? 'already-selected' : 'default-click');
        if (!checkbox.classList.contains(SELECTED)) {
          checkbox.click();
          schedule(); 
          break;
        }
      }
      report();
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(scan, 0);
    }

    function watchBriefly() {
      observer?.disconnect();
      clearTimeout(stopTimer);
      observer = new MutationObserver(schedule);
      observer.observe(widget, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-disabled', 'inert']
      });
      stopTimer = setTimeout(() => observer.disconnect(), 3000);
      schedule();
    }

    widget.addEventListener('items-changed', schedule);
    widget.addEventListener('deal-bar-selected', event => {
      dealBarId = event.detail?.dealBarId ?? null;
      watchBriefly();
    });
    watchBriefly();
  }

  document.addEventListener('kaching-bundles-block-loaded', event => mount(event.detail?.component));
  
  function discover() {
    document.querySelectorAll('kaching-bundles-block').forEach(widget => {
      if (typeof widget.items === 'function' && typeof widget.pricing === 'function') mount(widget);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', discover, { once: true });
  else discover();
})();